export function debounce(func, delay, leading) {
  let timerId;

  return (...args) => {
    if (!timerId && leading) {
      func(...args);
    }
    clearTimeout(timerId);

    timerId = setTimeout(() => func(...args), delay);
  };
}

export function throttle(func, delay) {
  let timerId;
  let lastExecutedTime = 0;

  return (...args) => {
    const currentTime = Date.now();

    if (currentTime - lastExecutedTime >= delay) {
      func(...args);
      lastExecutedTime = currentTime;
    } else {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        func(...args);
        lastExecutedTime = currentTime;
      }, delay);
    }
  };
}

export function dispatchEvent(eventName, detail) {
  document.dispatchEvent(new CustomEvent(eventName, { detail }));
}

export function refs(el) {
  const refs = {};

  el.querySelectorAll('[data-ref]').forEach((refEl) => {
    let key = refEl.dataset.ref;
    const keyMatch = key.match(/^\[(.+)\]$/);
    if (keyMatch) {
      key = keyMatch[1];
      if (!refs[key]) {
        refs[key] = [refEl];
      } else {
        refs[key].push(refEl);
      }
    } else {
      refs[key] = refEl;
    }
  });

  return refs;
}

export function domReady() {
  return new Promise((resolve) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', resolve, { once: true });
    } else {
      resolve();
    }
  });
}

export async function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
